
export const accountNumbersToSum = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2031, 2032];
export const accountNumbersProduktionsOmkostning = [3190, 3748, 2010, 2040];
export const accountNumbersAdministrationsOmkostninger = [3120, 3170, 3182, 3205, 3810, 3815, 3820, 3825, 3840, 3850, 3870];

